export const LOADER_STATUS = "boilderplate/EWBRECO_FETCH/LOADER_STATUS";
export const SET_ENTITY_LIST = "boilderplate/EWBRECO_FETCH/SET_ENTITY_LIST";
export const SELECTED_ENTITY = "boilderplate/EWBRECO_FETCH/SELECTED_ENTITY";
export const PROFILE_DATA = "boilderplate/EWBRECO_FETCH/PROFILE_DATA";
export const SELECTED_GSTINS = "boilderplate/EWBRECO_FETCH/SELECTED_GSTINS";
export const STORE_PERIOD = "boilderplate/EWBRECO_FETCH/STORE_PERIOD";
export const TOTAL_REOCRDS = "boilderplate/EWBRECO_FETCH/TOTAL_REOCRDS";
export const TABLE_DATA =
  "boilerplate/EWBRECO_FETCH/TABLE_DATA";

export const dataType = [
  {
    label: "EWB-Outward",
    value: "EWB-Outward",
  },
  {
    label: "EWB-Inward",
    value: "EWB-Inward",
  },
  {
    label: "E-Invoice",
    value: "E-Invoice",
  },
];

export const fetchHeaders = [
  {
    value: "History",
    id: "1",
  },
  {
    value: "View",
    id: "2",
  },
];

export const viewOutwardSubHeaders = [
  {
    value: "EWB-Outward",
    id: "1",
  },
  {
    value: "E-Invoice",
    id: "2",
  },
  {
    value: "Outward Register",
    id: "3",
  },
];
export const viewInwardSubHeaders = [
  {
    value: "EWB-Inward",
    id: "1",
  },
  {
    value: "Purchase Register",
    id: "2",
  },
];
